<template>
  <v-container fluid>
    <v-app-bar dense flat>
      <div class="text-lg-h5" style="font-weight: 300">Job Description</div>
      <v-spacer></v-spacer>
      <v-breadcrumbs
        customDivider
        divider="/"
        large
        :items="path"
      ></v-breadcrumbs>
    </v-app-bar>

    <!-- PDF Viewer Iframe (Desktop) / Mobile Placeholder -->
    <div
      v-if="pdfBase64 && pdfBase64[0]"
      :style="{
        height: isMobile ? 'auto' : '85vh',
        minHeight: isMobile ? '300px' : '700px',
        position: 'relative',
        background: isMobile ? '#ffffff' : '#525659'
      }"
      id="scollStyle"
    >
      <!-- Loader while Blob URL is being created/loaded -->
      <div v-if="!pdfUrl" class="pa-4 white" style="height: 100%">
        <v-skeleton-loader type="image" height="100%" />
      </div>

      <template v-else>
        <!-- Mobile Optimized View -->
        <div
          v-if="isMobile"
          class="pa-12 text-center d-flex flex-column align-center justify-center"
        >
          <v-icon size="100" color="primary lighten-4">mdi-file-pdf-box</v-icon>
          <div class="mt-6 grey--text text--darken-2 headline font-weight-bold">
            Job Description Preview
          </div>
          <div class="mt-2 grey--text subtitle-1 mb-8">
            Your job description is ready. Since you are on a mobile device, please
            use the button below to view it.
          </div>
          <v-btn
            x-large
            color="primary"
            class="text-none px-8 rounded-lg shadow-lg"
            @click="openPdfInNewTab"
          >
            <v-icon left>mdi-eye</v-icon>
            Open Job Description
          </v-btn>
          <div class="mt-4 grey--text caption">
            The document will open in your device's native PDF viewer.
          </div>
        </div>

        <!-- Desktop Iframe View -->
        <iframe
          v-else
          :src="pdfUrl"
          width="100%"
          height="100%"
          frameborder="0"
          style="border: none; display: block"
          title="Job Description Viewer"
          loading="lazy"
        ></iframe>
      </template>
    </div>

    <!-- <v-btn
      @click="downloadFile(pdfBase64[0])"
      style="position: fixed; right: 2%; bottom: 10%"
      color="primary"
      rounded
    >
      <v-icon class="mx-3">print</v-icon>
      Download
    </v-btn> -->
  </v-container>
</template>
<script>
import FileMixin from "../../../mixins/FileMixin";
export default {
  name: "JobDescription",
  mixins: [FileMixin],
  data() {
    return {
      pdfUrl: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.getJobDescription();
    });
  },
  computed: {
    userData: function () {
      return this.$store.getters["auth/user"];
    },
    pdfBase64: function () {
      return this.$store.getters["Setup/setupGetters"].jobDescription;
    },
    path: function () {
      return this.$router.currentRoute.meta.breadcrumb;
    },
    jobs: function () {
      return this.$store.getters["Setup/setupGetters"].jobs;
    },
    isMobile() {
      // Production-grade mobile detection
      return (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        ) || window.innerWidth <= 768
      );
    },
  },
  watch: {
    pdfBase64: {
      immediate: true,
      handler(newValue) {
        if (newValue && newValue[0]) {
          this.generatePdfUrl(newValue[0]);
        }
      },
    },
  },
  methods: {
    generatePdfUrl(base64Data) {
      if (this.pdfUrl) {
        URL.revokeObjectURL(this.pdfUrl);
      }
      try {
        const binaryString = window.atob(base64Data);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        const blob = new Blob([bytes], { type: "application/pdf" });
        this.pdfUrl = URL.createObjectURL(blob);
      } catch (e) {
        console.error("Error generating PDF URL", e);
      }
    },
    openPdfInNewTab() {
      if (!this.pdfUrl) return;
      window.open(this.pdfUrl, "_blank");
    },
    getJobDescription: function () {
      const job = this.jobs.filter(
        (job) => job.position === this.$route.params.position
      );
      this.$store.dispatch("Setup/getJobDescription", {
        jobCode: job.code,
      });
    },
  },
  beforeDestroy() {
    if (this.pdfUrl) {
      URL.revokeObjectURL(this.pdfUrl);
    }
  },
};
</script>
<style scoped>
.shadow-lg {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
}
</style>
